import { createSelector } from 'reselect';
import { dataSources, apiCallStatus } from 'helpers/constants';
import { getAssetDataSourceType } from 'helpers/assetAndPowertrainFilterHelper';
import { getActiveTab, getMultiChart } from '../selectors';
import { getSelectedNotification } from '../../../../PowertrainOverview/Header/NotificationDropdown/selectors';
import { createErrorDataSelector } from 'selectors/selectorUtils';

const getDateSelection = ({ overview }) => {
    return overview.dateSelection;
};

const hasRawData = ({ operationalParameters }) => {
    return operationalParameters?.FFT?.data && Object.hasOwn(operationalParameters.FFT.data, 'dataValues')
        && operationalParameters?.FFT?.data?.dataValues?.length !== 0;
};

const hasRawDataV2 = ({ operationalParameters }) => {
    return operationalParameters?.FFTV2?.data?.length > 0 && Object.hasOwn(operationalParameters.FFTV2.data?.[0], 'dataValues')
        && operationalParameters?.FFTV2?.data?.[0]?.dataValues?.length !== 0;
};

const getIsCMDAsset = ({ powertrainAssetDetails }) => {
    const dataSourceType = getAssetDataSourceType(powertrainAssetDetails?.selectedAsset);
    return dataSourceType === dataSources?.CMD4;
};

const getSensorGatewayInfoOP = ({ sensorProperties }) => {
    return sensorProperties?.sensorGatewayInfo;
};

const getRawDownloadRawDataErrorData = ({ operationalParameters }) => {
    if (operationalParameters?.downloadRawDataLoadingStatus === apiCallStatus.ERROR) {
        return {
            loadingStatus: operationalParameters.downloadRawDataLoadingStatus,
            error: operationalParameters.downloadRawDataError,
            errorCode: operationalParameters.downloadRawDataError?.statusCode,
        };
    }
    return { loadingStatus: operationalParameters?.downloadRawDataLoadingStatus };
};

const getDownloadRawDataErrorData = createErrorDataSelector(getRawDownloadRawDataErrorData);

export const getModel = createSelector([
    getDateSelection,
    hasRawData,
    getActiveTab,
    getMultiChart,
    getIsCMDAsset,
    hasRawDataV2,
    getSelectedNotification,
    getSensorGatewayInfoOP,
    getDownloadRawDataErrorData
],
    (
        dateSelection,
        hasRawData,
        activeTab,
        multiChart,
        isCMDAsset,
        hasRawDataV2,
        selectedNotification,
        sensorGatewayInfo,
        downloadRawDataErrorData
    ) => {
        return {
            dateSelection,
            hasRawData,
            activeTab,
            multiChart,
            isCMDAsset,
            hasRawDataV2,
            selectedNotification,
            sensorGatewayInfo,
            downloadRawDataErrorData
        };
    });


